// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {
  getFirestore,
  getDocs,
  orderBy,
  doc,
  query,
  collection,
  where,
} from "firebase/firestore";
import { getAuth, signOut } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// const firebaseConfig = {
//   apiKey: "AIzaSyCKvTrXmxsZOeIFhNQMXODrvLUH87iVVho",
//   authDomain: "bastatransito-dev.firebaseapp.com",
//   projectId: "bastatransito-dev",
//   storageBucket: "bastatransito-dev.appspot.com",
//   messagingSenderId: "452559018865",
//   appId: "1:452559018865:web:8e70346f53417f96e074d0"
// };

//PROD - bastatransito.app@gmail.com
// const firebaseConfig = {
//   apiKey: "AIzaSyAeXWrbNJZxP8Paw8EiKxlrz7qMD6JSbrw",
//   authDomain: "basta-transito.firebaseapp.com",
//   projectId: "basta-transito",
//   storageBucket: "basta-transito.appspot.com",
//   messagingSenderId: "621719610713",
//   appId: "1:621719610713:web:f209733c54599b42e71848",
// };

const firebaseConfig = {
  apiKey: "AIzaSyD7392dIz3-4pgrd5y1fxJWmMwmQVTY4W8",
  authDomain: "basta-transito-a09d8.firebaseapp.com",
  projectId: "basta-transito-a09d8",
  storageBucket: "basta-transito-a09d8.appspot.com",
  messagingSenderId: "295552867870",
  appId: "1:295552867870:web:941750f9b5b52e5f0e580f"
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);

//Initialize firestore
export const db = getFirestore(app);

//Initialize Auth
export const auth = getAuth(app);

export const logOut = async () => {
   await signOut(auth);
} 

export const isUserAdmin  = async (userId: string) : Promise<boolean> => {
  try {
    const userCollection = collection(db, "users");
    const q = query(userCollection, where("uId", "==", userId));
    const querySnapshot = await getDocs(q);
    
    let isAdmin = false;

    querySnapshot.forEach((doc) => {
      const data = doc.data();
      if (data?.type === "admin") {
        isAdmin = true;
      }
    });    
    return isAdmin;
  } catch (error) {
    console.log("Error getting documents: ", error);
    return false;
  }
} 

